import { Box, Avatar } from "@mui/material";
import { Facebook, YouTube, Instagram, WhatsApp } from "@mui/icons-material";
import theme from "../../theme/theme";

const Footer = () => {
  return (
    <>
      <h2>Footer</h2>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent=" space-evenly"
        // gridColumn="12 /span 1"
        // gridRow="3/4"
        justifySelf={{ md: "flex-end" }}
        className="social_links"
      >
        <a
          href="https://www.youtube.com"
          target={{ target: "blank" }}
          style={{ textDecoration: "none" }}
        >
          <Avatar sx={{ bgcolor: theme.palette.secondary.main }}>
            <YouTube />
          </Avatar>
        </a>
        <a href="https://www.facebook.com" target={{ target: "blank" }}>
          <Avatar sx={{ bgcolor: "#D9C750" }}>
            <Facebook />
          </Avatar>
        </a>
        <Avatar sx={{ bgcolor: "#D9C750" }}>
          <Instagram />
        </Avatar>
        <Avatar sx={{ bgcolor: "#D9C750" }}>
          <WhatsApp />
        </Avatar>
      </Box>
    </>
  );
};

export default Footer;
